import React from 'react'
import {WhyFBS, PursueMBA, CertificateComponent, StudentReviews, OurRecruiters, FAQComponent, MBAFinanceLanding,} from '../index'
import testimonials from './tempData'


const LandingPage =()=>{

    return (
        <>
        <MBAFinanceLanding/>
        <br/>
        <WhyFBS/>
        <br/>
        <PursueMBA/>
        <br/>
        <br/>
        <br/>
        <br/>
       <CertificateComponent/>
       <br/>
       <br/>
       <br/>
       <br/>
       <StudentReviews  testimonials={testimonials}/>
       <br/>
       <OurRecruiters/>
       <br/>
       <FAQComponent/>
       <br/>
      
        </>
    )
}


export default LandingPage